import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, Container, Tab, Tabs } from "react-bootstrap";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { PDFPreviewFile } from "../../../components/PDFFileHandler";
import KeepPdfContsService from "../../../services/keeppdfcont.service";
import FileUploadsService from "../../../services/fileupload.service";

export default function ImportKeepFile() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: KeepPdfContsService.getKeepPdfConts(state?.row?.Id),
      callback: (res) =>
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: FileUploadsService.getFileUploads(
            "จัดเก็บสัญญา",
            res.Keep_File
          ),
          callback: (res) =>
            setPreview(new Blob([res], { type: "application/pdf" }))
        })
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>จัดเก็บสัญญา</title>
        <meta name="description" content="MA Service Contract Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs justify activeKey={state.name}>
          <Tab eventKey="contract" title="สัญญางานบริการ MA"></Tab>
          <Tab eventKey="store" title="จัดเก็บสัญญา">
            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Header className="p-3 bg-transparent border-bottom-0">
                <Card.Title className="mb-0 fs-2 text-center">
                  แสดงตัวอย่างใบจัดเก็บสัญญา
                </Card.Title>
              </Card.Header>

              <Card.Body>
                <PDFPreviewFile pdfFile={preview} />
              </Card.Body>

              <Card.Footer className="text-center border-top-0 bg-transparent">
                <Button
                  variant="outline-secondary"
                  className="px-4 py-2 text-dark rounded-pill"
                  onClick={() => navigate("/MA_service", { state })}
                >
                  ย้อนกลับ
                </Button>
              </Card.Footer>
            </Card>
          </Tab>
          <Tab
            eventKey="requirements"
            title="ขัอกำหนดเพิ่มเติม (คำสั่งพิเศษ)"
          ></Tab>
          <Tab eventKey="lumsum" title="กำหนดอะไหล่ในสัญญา Lumsum"></Tab>
        </Tabs>
      </Container>
    </>
  );
}
